/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { addProtocolIfAbsent, isURL } from 'common/util/url';
export const InvisibleSubmit = () => {
  return <input
  //hack to allow form submits via enter button
  attrs={{
    type: "submit",
    tabindex: -1
  }} style={{
    position: "absolute",
    left: "-9999px",
    width: "1px",
    height: "1px"
  }} data-sentry-component="InvisibleSubmit" data-sentry-source-file="mixins.tsx" />;
};
export function renderSegmentLabel(label: string) {
  if (isURL(label)) {
    return <a attrs={{
      href: addProtocolIfAbsent(label),
      target: "_blank",
      rel: "noopener noreferrer"
    }}>{label}</a>;
  }
  return label;
}
export function ReCaptcha(_ref: {
  recaptchaKey: string;
}) {
  let {
    recaptchaKey
  }: {
    recaptchaKey: string;
  } = _ref;
  return <div sel='.recaptcha' key='g-recaptcha' attrs={{
    id: "recaptcha",
    class: "g-recaptcha ",
    'data-sitekey': recaptchaKey,
    'data-size': "invisible",
    'data-error-callback': "handleRecaptchaError",
    'data-callback': "handleRecaptchaResponse"
  }} data-sentry-component="ReCaptcha" data-sentry-source-file="mixins.tsx" />;
}